// client/src/pages/Unauthorized/index.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

/**
 * Page d'accès non autorisé
 * Affichée lorsque l'utilisateur n'a pas les droits nécessaires pour accéder à une ressource
 */
const UnauthorizedPage = () => {
  const { user, logout } = useAuth();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="max-w-md w-full bg-white rounded-lg shadow-md p-8 text-center">
        <div className="text-6xl font-bold text-red-500 mb-4">403</div>
        <h1 className="text-2xl font-bold mb-4">Accès non autorisé</h1>
        <p className="text-gray-600 mb-6">
          Vous n'avez pas les permissions nécessaires pour accéder à cette page.
        </p>
        
        {user && (
          <div className="mb-6 p-4 bg-gray-100 rounded-lg">
            <p className="text-gray-600 mb-2">
              Connecté en tant que: <span className="font-bold">{user.fullName}</span>
            </p>
            <p className="text-gray-600">
              Rôle: <span className="font-bold">{user.role}</span>
            </p>
          </div>
        )}
        
        <div className="space-y-3">
          <Link to="/" className="block w-full bg-primary-500 text-white py-3 px-4 rounded hover:bg-primary-600 transition">
            Retour à l'accueil
          </Link>
          
          <button
            onClick={logout}
            className="block w-full bg-gray-300 text-gray-700 py-3 px-4 rounded hover:bg-gray-400 transition"
          >
            Se déconnecter
          </button>
        </div>
      </div>
    </div>
  );
};

export default UnauthorizedPage;
